import colors from 'vuetify/es5/util/colors'
var themes = {
  light: {
    primary: '#1f337d',
    secondary: '#F4F4F5',
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  },
  dark: {
    primary: colors.blue.darken2,
    secondary: colors.grey.lighten2,
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  }
}

const alluraAmbientes = ['allura_cdc', 'home_design', 'romanzza', 'bau'];

if (alluraAmbientes.includes(window.env.VUE_APP_AMBIENTE)) {
  themes = {
    light: {
      primary: '#18c67b',
      secondary: '#15211b',
      accent: colors.blue.accent1,
      error: colors.red.accent2,
      info: colors.blue,
      success: colors.green,
      warning: colors.amber
    }
  }
} else {
  switch (window.env.VUE_APP_AMBIENTE) {
    case 'omnilink':
      themes = {
        light: {
          primary: '#176AAD',
          secondary: '#39A2FA',
          accent: colors.blue.accent1,
          error: colors.red.accent2,
          info: colors.blue,
          success: colors.green,
          warning: colors.amber
        }
      }
      break;
    case 'cdc':
      themes = {
        light: {
          primary: '#1f337d',
          secondary: '#1f337d',
          accent: colors.blue.accent1,
          error: colors.red.accent2,
          info: colors.blue,
          success: colors.green,
          warning: colors.amber
        }
      }
      break;
    case 'size_multiplo':
      themes = {
        light: {
          primary: '#000000',
          secondary: '#FFFFFF',
          accent: colors.blue.accent1,
          error: colors.red.accent2,
          info: colors.blue,
          success: colors.green,
          warning: colors.amber
        }
      }
      break;
    case 'millennium_cdc':
      themes = {
        light: {
          primary: '#0f1e89',
          secondary: '#111111',
          accent: colors.blue.accent1,
          error: colors.red.accent2,
          info: colors.blue,
          success: colors.green,
          warning: colors.amber
        }
      }
      break;
    case 'allura_cdc':
      themes = {
        light: {
          primary: '#18c67b',
          secondary: '#15211b',
          accent: colors.blue.accent1,
          error: colors.red.accent2,
          info: colors.blue,
          success: colors.green,
          warning: colors.amber
        }
      }
      break
    case 'midas_cdc':
      themes = {
        light: {
          primary: '#102842',
          secondary: '#F3CD74',
          accent: colors.blue.accent1,
          error: colors.red.accent2,
          info: colors.blue,
          success: colors.green,
          warning: colors.amber
        }
      }
      break
  }
}

let background = '/assets/imgs/background.svg'
let logo = '/assets/imgs/logo.svg'

try {
  if (localStorage.ambiente) {
    require('@/assets/imgs/' + localStorage.ambiente + '/background.svg')
    background = '/assets/imgs/' + localStorage.ambiente + '/background.svg'
  }
} catch { }
try {
  if (localStorage.ambiente) {
    require('@/assets/imgs/' + localStorage.ambiente + '/logo.svg')
    logo = '/assets/imgs/' + localStorage.ambiente + '/logo.svg'

    var favicon = document.getElementById('custom-favicon')
    favicon.setAttribute('href', '/assets/imgs/' + localStorage.ambiente + '/favicon.svg')
  }
} catch { }

export default {
  dark: false,
  options: {
    customProperties: true,
    dense: false
  },
  background,
  logo,
  themes: themes
}
